export var EInputType = /*#__PURE__*/function (EInputType) {
  EInputType["search"] = "search";
  EInputType["map"] = "map";
  EInputType["mobile"] = "mobile";
  EInputType["mainpage"] = "mainpage";
  EInputType["tablet"] = "tablet";
  EInputType["custom"] = "custom";
  return EInputType;
}({});
export var ESuggestType = /*#__PURE__*/function (ESuggestType) {
  ESuggestType["city"] = "city";
  ESuggestType["district"] = "district";
  ESuggestType["railway"] = "railway";
  ESuggestType["underground"] = "underground";
  ESuggestType["businessCenter"] = "businessCenter";
  ESuggestType["shoppingCenter"] = "shoppingCenter";
  ESuggestType["road"] = "road";
  ESuggestType["village"] = "village";
  ESuggestType["newbuilding"] = "newbuilding";
  ESuggestType["geo"] = "geo";
  ESuggestType["builder"] = "builder";
  ESuggestType["coworking"] = "coworking";
  ESuggestType["regionalDistrict"] = "regionalDistrict";
  return ESuggestType;
}({});
export var EMessageType = /*#__PURE__*/function (EMessageType) {
  EMessageType["EMPTY"] = "EMPTY";
  EMessageType["ERROR"] = "ERROR";
  return EMessageType;
}({});
/** Значения соответствуют css классам */
export var ETruncation = /*#__PURE__*/function (ETruncation) {
  ETruncation["One"] = "trunc_1";
  ETruncation["Two"] = "trunc_2";
  return ETruncation;
}({});